const UPDATE_APPOINTMENT_WINDOW = 'updateAppointmentWindow';
const COMPLETE_STOP = 'completeStop';
const SHIPMENT_ARRIVED = 'shipmentArrived';
const EDIT_ESTIMATED_ARRIVAL = 'editEstimatedArrival';
const EDIT_ARRIVAL = 'editArrivalDate';
const EDIT_DISCHARGE = 'editDischargeDate';
const EDIT_LAST_FREE_DAY = 'editLastFreeDate';
const CHANGE_SHIPPER = 'changeShipper';
const CHANGE_CARRIER = 'changeCarrier';
const UPDATE_CARRIER_COST = 'updateCarrierCost';
const SEND_DELIVERY_ORDER = 'sendDeliveryOrder';
const BULK_ACCESSORIAL = 'multipleAccessorialRequest';
const BULK_APPLY_ADMIN_NOTES = 'bulkApplyAdminNotes';
const SEND_BILL_OF_LADING = 'sendBillOfLading';
const UPDATE_EARLIEST_GET_EMPTY = 'earliestDateToGetEmpty';
const UPDATE_EARLIEST_RETURN = 'earliestReturnDate';
const UPDATE_LAST_CUT = 'lastCutDate';
const UPDATE_EMPTY_RETURN = 'emptyReturnedDate';
const CHANGE_CONSIGNEE = 'changeConsignee';
const SEND_RATE_CONFIRMATION = 'sendRateConfirmation';
const ADD_YARDS_IN_BULK = 'addYardsInBulk';
const EVALUATE_BILLING_STATUS = 'evaluateBillingStatus';
const CLOSE_SHIPMENT = 'closeShipment';
const UPDATE_REVIEW_DATE = 'updateReviewDate';
const UPDATE_ACCOUNTING_REVIEW_DATE = 'updateAccountReviewDate';
const OVERRIDE_BILLING_STATUS = 'overrideBillingStatus';
const MARK_BILLING_STATUS_PENDING_REVIEW = 'markBillingStatusPendingReview';
const EDIT_ETA_TO_FINAL_RAIL_FACILITY = 'updateEtaToFinalRailFacility';
const EDIT_LFD_AT_RAIL_FACILITY = 'updateRailLfd';
const BULK_CLEAR_TAGS = 'bulkClearTags';
const BULK_ADD_TAGS = 'bulkAddTags';
const BULK_UPLOAD_DOCUMENTS = 'bulkUploadDocuments';
const BULK_ADD_REFERENCE_NUMBERS = 'bulkAddReferenceNumbers';
const UPDATE_PRENOTICE_TO_FINAL = 'updatePrenoticeToFinal';
const UPDATE_FINAL_TO_PRENOTICE = 'updateFinalToPrenotice';
const BULK_ADD_BRIDGE_CODES = 'bulkAddBridgeCodes';
const BULK_ADD_TERMINAL_HOLDS = 'bulkAddTerminalHolds';
const UPDATE_EMPTY_READY_FOR_PICKUP = 'emptyReadyForPickupDate';
export const massUpdateActions = {
    UPDATE_APPOINTMENT_WINDOW,
    UPDATE_EARLIEST_GET_EMPTY,
    UPDATE_EARLIEST_RETURN,
    UPDATE_LAST_CUT,
    UPDATE_EMPTY_RETURN,
    COMPLETE_STOP,
    SHIPMENT_ARRIVED,
    EDIT_ESTIMATED_ARRIVAL,
    EDIT_ARRIVAL,
    EDIT_DISCHARGE,
    EDIT_LAST_FREE_DAY,
    CHANGE_SHIPPER,
    CHANGE_CARRIER,
    UPDATE_CARRIER_COST,
    SEND_DELIVERY_ORDER,
    BULK_ACCESSORIAL,
    BULK_APPLY_ADMIN_NOTES,
    SEND_BILL_OF_LADING,
    CHANGE_CONSIGNEE,
    SEND_RATE_CONFIRMATION,
    ADD_YARDS_IN_BULK,
    EVALUATE_BILLING_STATUS,
    CLOSE_SHIPMENT,
    UPDATE_REVIEW_DATE,
    UPDATE_ACCOUNTING_REVIEW_DATE,
    OVERRIDE_BILLING_STATUS,
    MARK_BILLING_STATUS_PENDING_REVIEW,
    EDIT_ETA_TO_FINAL_RAIL_FACILITY,
    EDIT_LFD_AT_RAIL_FACILITY,
    BULK_CLEAR_TAGS,
    BULK_ADD_TAGS,
    BULK_UPLOAD_DOCUMENTS,
    BULK_ADD_REFERENCE_NUMBERS,
    UPDATE_PRENOTICE_TO_FINAL,
    UPDATE_FINAL_TO_PRENOTICE,
    BULK_ADD_BRIDGE_CODES,
    BULK_ADD_TERMINAL_HOLDS,
    UPDATE_EMPTY_READY_FOR_PICKUP,
};
